import { Link } from 'react-router-dom';
import { Plus, PawPrint } from 'lucide-react';
import { usePets } from '../../contexts/PetsContext';
import { useFamily } from '../../contexts/FamilyContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import SkeletonScreen from '../../components/feedback/SkeletonScreen';
import PetCard from './components/PetCard';
import PetCardSkeleton from './components/PetCardSkeleton';
import { ROUTES } from '../../config/constants';

const PetsListPage = () => {
  const { pets, isLoading, isEmpty } = usePets();
  const { family } = useFamily();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-slate-900">Mascotas</h1>
          {family && (
            <p className="text-sm text-slate-500 truncate">
              {family.name}
            </p>
          )}
        </div>
        <Button
          variant="primary"
          size="sm"
          leftIcon={Plus}
          as={Link}
          to="/pets/new"
        >
          Agregar
        </Button>
      </div>

      {isLoading ? (
        <SkeletonScreen label="Cargando mascotas">
          <div className="flex flex-col gap-3">
            <PetCardSkeleton />
            <PetCardSkeleton />
            <PetCardSkeleton />
          </div>
        </SkeletonScreen>
      ) : isEmpty ? (
        <Card className="flex flex-col items-center gap-3 py-12 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-100">
            <PawPrint className="h-7 w-7 text-brand-700" aria-hidden="true" />
          </div>
          <h2 className="text-base font-semibold text-slate-900">
            No hay mascotas todavía
          </h2>
          <p className="max-w-xs text-sm text-slate-500">
            Agregá tu primera mascota para empezar a coordinar su cuidado con
            toda la familia.
          </p>
          <Button
            variant="primary"
            size="sm"
            leftIcon={Plus}
            as={Link}
            to="/pets/new"
            className="mt-2"
          >
            Agregar mascota
          </Button>
        </Card>
      ) : (
        <div className="flex flex-col gap-3">
          {pets.map((pet) => (
            <PetCard key={pet.id} pet={pet} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PetsListPage;